import PersonaPage from "./PersonaPage";
import { questionsGrandparent } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für die Oma?",
    a: "Bei Großmüttern trägt fast immer ein sinnliches Detail die Rede — ein Duft aus der Küche, eine Handbewegung, ein Lied. Beginnen Sie dort, und die Worte finden sich fast von selbst.",
  },
  {
    q: "Ich bin ein Enkelkind — darf ich vor der ganzen Familie sprechen?",
    a: "Sehr gerne. Eine Rede von einem Enkelkind bringt einen Ton in die Trauerfeier, den niemand sonst treffen kann: Dankbarkeit ohne die Last der Erwachsenenjahre.",
  },
  {
    q: "Wie lang soll eine Trauerrede für die Großmutter sein?",
    a: "Meist trägt schon ein einziger warmer Absatz. Bei Großmüttern ist Kürze oft die größte Würde — ein Bild, ein Satz, ein Dank. Wir helfen, diese Balance zu finden.",
  },
  {
    q: "Können wir ein Lied oder Gebet einbinden?",
    a: "Ja. Sie können im Fragebogen einen Vers oder ein Lied hinterlegen — wir binden es behutsam ein.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für den Großvater", to: "/trauerrede-opa" },
  { label: "Trauerrede für die Mutter", to: "/trauerrede-mutter" },
  { label: "Trauerrede für die Schwester", to: "/trauerrede-schwester" },
];

export default function TrauerredeOma() {
  return (
    <PersonaPage
      slug="trauerrede-oma"
      metaTitle="Trauerrede für die Oma schreiben — persönlich für die Großmutter | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für die Oma. Aus Küchendüften, Liedern und geteilten Nachmittagen entsteht in acht Fragen ein warmer Entwurf. Ab 29 €."
      eyebrow="Trauerrede · Oma · Großmutter"
      headline={
        <>
          Eine Trauerrede für die Oma.
          <br />
          <span className="italic text-umber">Ihre Küche. Ihre Lieder. Ihre Stimme.</span>
        </>
      }
      intro="Manche Menschen leben so still, dass man erst später merkt, wie viele Räume sie erfüllt haben. Ein behutsamer erster Entwurf für Ihre Großmutter — aus acht ruhigen Fragen und den Nachmittagen, die nur Enkelkinder kennen."
      heroImage="https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1920&q=80"
      heroImageAlt="Ein hölzerner Küchentisch mit einer Tasse Tee im warmen Licht — Sinnbild einer Trauerrede für die Oma"
      questions={questionsGrandparent}
      exampleQuote={
        <>
          „Wenn ich an sie denke, rieche ich zuerst ihre Küche. Dann höre ich, wie sie leise die
          Radio-Musik mitsummt, während der Teekessel pfeift. Ich weiß bis heute nicht, wie sie es
          geschafft hat, jeden Nachmittag so aussehen zu lassen, als ob nichts wichtiger wäre als
          man selbst. Aber ich weiß, dass ich das mitnehme. Für immer.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
